import { useSelectedDealer } from "components";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { QuestionsDashboardQueryKeys } from "modules/QuestionsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { QuestionID } from "models";

type DeleteQuestionPayload = {
  id: QuestionID;
};

export const useDeleteQuestionMutation = () => {
  const { selectedDealer } = useSelectedDealer();

  return useTypedMutation<DeleteQuestionPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/questions/delete", payload, ENV.dealerBaseURL);
    },
    onSuccess: ({ id }) => {
      const defaultQuestions = typedQueryClient.getQueryData(QuestionsDashboardQueryKeys.defaultQuestions);
      const defaultQuestionIdx = defaultQuestions?.findIndex(question => question.id === id) ?? -1;
      if (defaultQuestions && defaultQuestionIdx !== -1)
        typedQueryClient.setQueryData(QuestionsDashboardQueryKeys.defaultQuestions, defaultQuestions.toSpliced(defaultQuestionIdx, 1));

      const dealerQuestions = typedQueryClient.getQueryData(QuestionsDashboardQueryKeys.dealerQuestions(selectedDealer?.id));
      const dealerQuestionIdx = dealerQuestions?.findIndex(question => question.id === id) ?? -1;
      if (!dealerQuestions || dealerQuestionIdx === -1) return;

      typedQueryClient.setQueryData(QuestionsDashboardQueryKeys.dealerQuestions(selectedDealer?.id), dealerQuestions.toSpliced(dealerQuestionIdx, 1));
    }
  });
};
